
const businessTypeConfigList = [
  {
    businessTypeName: '账号问题',
    businessType: 7,
    icon: 'https://img-ys011.didistatic.com/static/kefu_center/do1_Tpi5ihnvuz1kfaysWETe',
    roleInfoList: [{
      role_name: '乘客',
      role_type: 1,
      dictId: '567582'
    }, {
      role_name: '司机',
      role_type: 2,
      dictId: '572492',
    }],
  },
  {
    businessTypeName: '快车',
    businessType: 7,
    icon: 'https://img-ys011.didistatic.com/static/kefu_center/businesstype_kuaiche_icon.png',
    roleInfoList: [{
      role_name: '乘客',
      role_type: 1,
      dictId: '567582'
    }, {
      role_name: '司机',
      role_type: 2,
      dictId: '572492',
    }],
  },
  {
    businessTypeName: '专车',
    businessType: 1,
    icon: 'https://img-ys011.didistatic.com/static/kefu_center/businesstype_zhuanche_icon.png',
    roleInfoList: [{
      role_name: '乘客',
      role_type: 1,
      dictId: '567576'
    }, {
      role_name: '司机',
      role_type: 2,
      dictId: '572494',
    }],
  },
  {
    businessTypeName: '出租车',
    businessType: 30,
    icon: 'https://img-ys011.didistatic.com/static/kefu_center/businesstype_chuzu_icon.png',
    roleInfoList: [{
      role_name: '乘客',
      role_type: 1,
      dictId: '572474'
    }, {
      role_name: '司机',
      role_type: 2,
      dictId: '572472',
    }],
  },
  {
    businessTypeName: '顺风车',
    businessType: 3,
    icon: 'https://img-ys011.didistatic.com/static/kefu_center/businesstype_shunfengche_icon.png',
    roleInfoList: [{
      role_name: '乘客',
      role_type: 1,
      dictId: '572476'
    }, {
      role_name: '司机',
      role_type: 2,
      dictId: '572478',
    }],
  },
  {
    businessTypeName: '企业订单',
    businessType: 4,
    icon: 'https://img-ys011.didistatic.com/static/kefu_center/businesstype_qiye_icon.png',
    roleInfoList: [{
      role_name: '乘客',
      role_type: 1,
      dictId: '572566'
    }, {
      role_name: '出行人',
      role_type: 31,
      dictId: '573164',
    }],
  },
  {
    businessTypeName: '豪华车',
    businessType: 29,
    icon: 'https://img-ys011.didistatic.com/static/kefu_center/do1_8ecvLSs2ufXrAADCt5UZ',
    roleInfoList: [{
      role_name: '乘客',
      role_type: 1,
      dictId: '567550'
    }, {
      role_name: '司机',
      role_type: 2,
      dictId: '567552',
    }],
  },
  {
    businessTypeName: '代驾',
    businessType: 6,
    icon: 'https://img-ys011.didistatic.com/static/kefu_center/businesstype_daijia_icon.png',
    roleInfoList: [{
      role_name: '乘客',
      role_type: 1,
      dictId: '572508'
    }, {
      role_name: '司机',
      role_type: 2,
      dictId: '572510',
    }],
  },
  {
    businessTypeName: '单车',
    businessType: 46,
    icon: 'https://img-ys011.didistatic.com/static/kefu_center/businesstype_danche_icon.png',
    isMoreRoles: false,
    roleInfoList: [{
      role_name: '乘客',
      role_type: 1,
      dictId: '572512',
    }],
  },
  {
    businessTypeName: '电单车',
    businessType: 37,
    icon: 'https://img-ys011.didistatic.com/static/kefu_center/businesstype_diandanche_icon_v1.png',
    isMoreRoles: false,
    roleInfoList: [{
      role_name: '乘客',
      role_type: 1,
      dictId: '572574',
    }],
  },
  {
    businessTypeName: '金融',
    businessType: 25,
    icon: 'https://img-ys011.didistatic.com/static/kefu_center/businesstype_jinrong_icon.png',
    isMoreRoles: false,
    roleInfoList: [{
      role_name: '乘客',
      role_type: 1,
      dictId: '573162',
    }],
  },
  {
    businessTypeName: '货运',
    businessType: 84,
    icon: 'https://img-ys011.didistatic.com/static/kefu_center/businesstype_huoyun_icon.png',
    roleInfoList: [{
      role_name: '货主',
      role_type: 22,
      dictId: '572496'
    }, {
      role_name: '司机',
      role_type: 2,
      dictId: '572572',
    }],
  },
  {
    businessTypeName: '小桔充电',
    businessType: 43,
    icon: 'https://img-ys011.didistatic.com/static/kefu_center/businesstype_xiaojuchongdian_icon.png',
    roleInfoList: [{
      role_name: '商户',
      role_type: 28,
      dictId: '572568'
    }, {
      role_name: '司机',
      role_type: 2,
      dictId: '572568',
    }],
  },
  {
    businessTypeName: '滴滴加油',
    businessType: 20,
    icon: 'https://img-ys011.didistatic.com/static/kefu_center/businesstype_didijiayou_icon.png',
    roleInfoList: [{
      role_name: '商户',
      role_type: 28,
      dictId: '572570',
    }, {
      role_name: '司机',
      role_type: 2,
      dictId: '572570',
    }],
  },
  {
    businessTypeName: '失物寻找',
    businessType: 7,
    icon: 'https://img-ys011.didistatic.com/static/kefu_center/businesstype_lost_icon.png',
    isMoreRoles: false,
    roleInfoList: [{
      role_name: '乘客',
      role_type: 1,
      dictId: '572480',
    }],
  },
]

const IMG_STATUS = {
  UPLOADING: 'UPLOADING',
  SUCCESS: 'SUCCESS',
  ERROR: 'ERROR',
}

const IMG_STATUS_TEXT = {
  [IMG_STATUS.UPLOADING]: '上传中...',
  [IMG_STATUS.SUCCESS]: '上传成功',
  [IMG_STATUS.ERROR]: '上传失败',
}

const UPLOAD_CODE = {
  INVALID: "100002", // 鉴黄接口表明非法
}

export {
  businessTypeConfigList,
  UPLOAD_CODE,
  IMG_STATUS_TEXT,
  IMG_STATUS,
};